module.exports = {
  "my.topic": "My Topic",
  "reply.topic": "Replied Topic",
  "his.topic": "Their topics",
  "pub.topic": "My topics"
}


// WEBPACK FOOTER //
// ./src/pages/myTopic/i18n/locale.en.js